import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./App.css";
import LoginNew from "./LandingPageNew/index";
import Login from "./LandingPage/index";
import Routing from "./Routes";
import { useNavigate, useLocation } from "react-router-dom";
import { useSessionTimeout } from "./CommonComponents/useSessionTimeout";
import TermsOfService from "./CommonComponents/TermsOfService";
import PrivacyPolicy from "./CommonComponents/PrivacyPolicy";
import axios from "axios";

const App = () => {
  const slug = useParams();
  // useSessionTimeout();

  const navigate = useNavigate()

  const user = JSON.parse(localStorage.getItem("userDetails"))

  const removeStorage = () => {
    localStorage.removeItem('Allowed_access')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('expireTime')
    localStorage.removeItem('propertyStatus')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('userDetails')
  }

  const checkToken = async () => {

    const refreshToken = localStorage.getItem("refreshToken")

    if(refreshToken){

    
try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}check_refresh_token`, {
        refresh_token : localStorage.getItem('refreshToken')
      })
      if(response?.data?.valid === true){
        if(user?.user_role == 2){
            navigate('/dashboard')
        }else if(user?.user_role == 5){
          navigate('/dashboard')
        }else if(user?.user_role == 4){
          navigate("/dashboard")
        }else if(user?.user_role == 3){
          navigate("/upcoming_visitor")
        }else {
          navigate("/dashboard")
        }
        
      }else{
        removeStorage()
        navigate('/')
      }
    } catch (error) {
      removeStorage()
      navigate('/')
      // console.log(error)
    }
  }else{
    removeStorage()
      navigate('/')
  }
  }

  useEffect(() => {
    checkToken()
  }, [])

  return (
    <>
      <Routes>
        <Route path="/termsofservice" element={<TermsOfService /> } />
        <Route path="/privacypolicy" element={<PrivacyPolicy /> } />
        <Route path="/" element={<Login />} />
        {/* <Route path="/login" element={<Login />} /> */}
        <Route path="/*" element={<Routing />} />
      </Routes>
    </>
  );
};

export default App;
